module.exports = __webpack_public_path__ + "img/357.28e5bf07.jpg";